import React from 'react';
import './UniversitiesPage.css';  // Ensure the CSS file is linked

const UniversitiesPageDent = () => {
    // Example data for universities
    const universities = [
        { name: "Sapienza University of Rome", image: "https://images.shiksha.com/mediadata/images/1453289462phpq2gbwh.jpeg", link: "https://www.uniroma1.it/" },
        { name: "University of Siena", image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTKf1Dwe7Jnp6Owx4EyCmIgFoUj1wmaFa1NHg&s", link: "https://www.unisi.it/" },
    ];

    return (
        <div className="universities-container">
            <h1>Universities Offering Dentistry Programs in English in Italy</h1>
            <div className="region">
                <h2>Central Italy</h2>
                <div className="university-grid">
                    {universities.slice(0, 5).map((uni, index) => (
                        <a key={index} href={uni.link} target="_blank" rel="noopener noreferrer">
                            <div className="university-card" style={{ backgroundImage: `url(${uni.image})` }}>
                                <div className="university-name">{uni.name}</div>
                            </div>
                        </a>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default UniversitiesPageDent;